<div id="add-next-stage-modal">
  @if (mode === 'addNext') {
    <div class="d-flex gap-4 mt-3 border-bt">
    <div>
      <p class="label current">
        {{ 'doktar_app.services.crop_monitoring.phenology.add_next_stage.current_stage' | translate }}
      </p>
      <p>{{ currentStage?.stageName ?? '-' }}</p>
    </div>
    <div>
      <p class="label current">
        {{ 'doktar_app.services.crop_monitoring.phenology.add_next_stage.due_date' | translate }}
      </p>
      <p>
        {{
          !currentStage
            ? '-'
            : (currentStage?.stageDate | luxonFormat: 'd LLLL, yyyy' : 'UTC' + selectedPlantation.offSet)
        }}
      </p>
    </div>
  </div>
  }
  <form [formGroup]="form" class="mt-3">
    <div class="row">
      <dk-input
        [label]="mode === 'addNext' ? 'doktar_app.services.crop_monitoring.phenology.add_next_stage.next_stage' : 'Stage'"
        [formGroup]="form"
        controlName="stageName" />
      <dk-datepicker
        label="doktar_app.activities.activity_date_single_date_label"
        [formGroup]="form"
        controlName="stageDate"
        placeholder="doktar_app.common.select_a_date"
        [minDate]="minDate"
        [maxDate]="maxDate" />
    </div>
    <div class="row mt-4">
      <div class="col-auto">
        <dk-button severity="secondary" label="doktar_app.common.cancel_button" (onClick)="cancel()" />
      </div>
      <div class="col">
        <dk-button
          severity="primary"
          [label]="mode === 'addNext' ? 'doktar_app.services.crop_monitoring.phenology.add_next_stage.add_stage' : 'Submit'"
          (onClick)="submit()"
          [disabled]="loading">
          @if (loading) {
            <i class="pi pi-spin pi-spinner-dotted"></i>
          }
        </dk-button>
      </div>
    </div>
  </form>
</div>
